import { VariantType } from 'notistack';

export const VARIANT_ERROR: { variant: VariantType } = { variant: 'error' };
export const VARIANT_SUCCESS: { variant: VariantType } = { variant: 'success' };
export const VARIANT_INFO: { variant: VariantType } = { variant: 'info' };
export const VARIANT_WARNING: { variant: VariantType } = { variant: 'warning' };
